import { render, staticRenderFns } from "./Template-drawer.vue?vue&type=template&id=5975e06c"
import script from "./Template-drawer.vue?vue&type=script&lang=js"
export * from "./Template-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports